export default "__VITE_ASSET__DA7_LT7q__"